import React, { useState } from 'react'
import { Formik, Field } from 'formik'
import * as Yup from 'yup'
import HttpStatus from 'http-status-codes'
import l10n from '../i18n/I18N'

import { config } from '../Init/Init'
import Spinner from '../Spinner/Spinner'
import { usePlayerStore } from '../../services/store'

// Each of these needs to be updated when CMS form fields change
function Textarea(props) {
  return (
    <div className="form-textarea">
      <h3>{props.entry.formTextareaTitle}</h3>
      <label>
        <p>{props.entry.formTextareaDescription}</p>
        <Field component="textarea" name={props.entry.id} />
      </label>
    </div>
  )
}

function Checkbox(props) {
  return (
    <div className="form-checkbox">
      <h3>{props.entry.formCheckboxTitle}</h3>
      <label>
        <Field type="checkbox" name={props.entry.id} />
        <p>{props.entry.formCheckboxDescription}</p>
      </label>
    </div>
  )
}

function Dropdown(props) {
  return (
    <div className="form-dropdown">
      <h3>{props.entry.formDropdownTitle}</h3>
      <label>
        {props.entry.formDropdownDescription}
        <Field component="select" name={props.entry.id}>
          <option defaultValue className="default=value"></option>
          {props.entry.formDropdownOptions.map(item => (
            <option value={item.option} key={item.option}>
              {item.option}
            </option>
          ))}
        </Field>
      </label>
    </div>
  )
}

// Needs to be updated when CMS form fields change
function FormFieldFactory(entry, index) {
  let field

  switch (entry.typeHandle) {
    case 'formDropdown':
      field = <Dropdown entry={entry} />
      break
    case 'formTextarea':
      field = <Textarea entry={entry} />
      break
    case 'formCheckbox':
      field = <Checkbox entry={entry} />
      break
    default:
      throw new Error('Unsupported form field type!')
  }

  return (
    <div key={index} className="form-field">
      {field}
    </div>
  )
}

function ToutFormContent(props) {
  const playerStore = usePlayerStore()
  const playerData = playerStore.useAllPlayerStore()
  const playerAccessToken = playerStore.use.accessToken()
  const playerLoginUser = playerStore.use.loginUser()

  const { formCtaText, formDescription, formDisplayTitle, formFields } = props.formData
  const [spinnerShow, setSpinnerShow] = useState(false)

  const sendFormData = values => {
    setSpinnerShow(true)
    let finalFormObject = {
      answers: [],
      userId: playerLoginUser.userId
    }
    Object.keys(values).forEach(key => {
      let formFieldToSend = {}
      const currentField = formFields.find(form => form.id === key)
      formFieldToSend.question = currentField[`${currentField.typeHandle}Description`]
      formFieldToSend.answer = values[key]
      finalFormObject.answers.push(formFieldToSend)
    })

    fetch(config.apiUrl + props.url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Authorization: `Bearer ${playerAccessToken.encryptedToken}`,
        'Content-Type': 'application/json',
        Accept: '*/*'
      },
      body: JSON.stringify(finalFormObject)
    })
      .then(response => {
        setSpinnerShow(false)
        if (!response.status === HttpStatus.OK) {
          console.log('[ToutFormContent - POST] - Bad Request?', response)
        }
      })
      .catch(err => {
        setSpinnerShow(false)
        console.log('[ToutFormContent - POST] - Fetch URL Bad?', err.errorReason, finalFormObject, playerData)
      })
      .finally(() => {
        if (props.onAction) {
          props.onAction({ type: 'formSubmitted' })
        }
      })
  }

  const requiredValidation = () => {
    return Yup.string()
      .trim()
      .required(l10n.t['validation.required'])
  }

  const getValidationObject = formArray => {
    let validationObj = {}

    formArray.forEach(entry => {
      validationObj[entry.id] = requiredValidation(l10n.t)
    })
    return Yup.object().shape(validationObj)
  }

  return (
    <Formik
      validationSchema={getValidationObject(formFields)}
      onSubmit={values => {
        sendFormData(values)
      }}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ errors, handleSubmit, isSubmitting }) => (
        <form onSubmit={handleSubmit} className={`form-content ${props.classes ? props.classes : ''}`}>
          <h2>{formDisplayTitle}</h2>
          <div>{formDescription}</div>
          {formFields.map((entry, index) => {
            return FormFieldFactory(entry, index)
          })}
          {spinnerShow && (
            <div className="spinner-container">
              <Spinner />
            </div>
          )}
          {Object.keys(errors).length > 0 && <div className="errors">{l10n.t['account.registerError']}</div>}
          <button className="btn btn-form-submit" type="submit" disabled={isSubmitting}>
            {formCtaText}
          </button>
        </form>
      )}
    </Formik>
  )
}

export default ToutFormContent
